import { SummaryState } from './interfaces';

export const storeName = 'summary';

export const summaryInitialState: SummaryState = {
  pendingFeedbackRequests: 0,
};
